import { MarketEntry } from '../types'
import { aggregateStats, MarketStats } from './aggregate-stats'
import { transformReserves } from './transformers'
import { useSparkRewardsByReserve } from './useSparkRewardsByReserve'
import { usePageChainId } from '@/domain/hooks/usePageChainId'
import { useMarketInfo } from '@/features/sparklend/common/data/market-info/useMarketInfo'

export interface UseMarketsResults {
  marketStats: MarketStats
  chainId: number
  activeAndPausedMarketEntries: MarketEntry[]
  frozenMarketEntries: MarketEntry[]
}

export function useMarkets(): UseMarketsResults {
  const { chainId } = usePageChainId()
  const { marketInfo } = useMarketInfo({ chainId })
  const sparkRewardsByReserve = useSparkRewardsByReserve({
    chainId,
    reserves: marketInfo.reserves,
  })

  const marketEntries = transformReserves(marketInfo, sparkRewardsByReserve)
  const activeAndPausedMarketEntries = marketEntries.filter((entry) => entry.reserveStatus !== 'frozen')
  const frozenMarketEntries = marketEntries.filter((entry) => entry.reserveStatus === 'frozen')

  return {
    marketStats: aggregateStats(marketInfo),
    activeAndPausedMarketEntries,
    frozenMarketEntries,
    chainId,
  }
}
